import React, { Component } from 'react'
import PropTypes from 'prop-types'

import cx from 'classnames'
import _ from 'lodash'

import OwnershipEntity from '../OwnershipEntity'

import { TYPES } from '../../constants'

import './style.scss'

export default class OwnershipList extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        childs: PropTypes.array,
        customData: PropTypes.object,
        hasBanner: PropTypes.bool,
        identifier: PropTypes.string.isRequired,
        mainId: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
        noHistory: PropTypes.bool,
        openDialog: PropTypes.func,
        parents: PropTypes.array,
        parentsPrimary: PropTypes.bool,
        renderBanner: PropTypes.func,
        toggledSections: PropTypes.object,
        toggleOwnershipSection: PropTypes.func.isRequired,
        translates: PropTypes.shape({
            from: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            notIdentified: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        }).isRequired,
        type: PropTypes.string,
    }

    static defaultProps = {
        type: TYPES.CHILDS,
        hasBanner: false,
        parentsPrimary: false,
    }

    render() {
        const {
            childs,
            openDialog,
            hasBanner,
            parentsPrimary,
            renderBanner,
            identifier,
            mainId,
            toggleOwnershipSection,
            toggledSections,
            parents,
            translates,
            noHistory,
            module,
            block,
            customData,
        } = this.props
        const { CHILDS, PARENTS } = TYPES

        const { type: currentListType } = this.props
        const mapData = currentListType === CHILDS ? childs : parents

        return mapData
            ? mapData.map(({ subject, relation, children: nextChilds, parents: nextParents }, key) => (
                  <div key={`list-content-${key}`} className={'ownership-content'}>
                      <div className={cx('ownership-borders')}>
                          <div
                              className={cx('ownership-border-vertical', {
                                  noHistory,
                                  childs: currentListType === CHILDS,
                                  parents: currentListType === PARENTS && parentsPrimary,
                                  first: key === 0,
                              })}
                          />
                      </div>
                      <div className={'ownership-childs'}>
                          <div className={'ownership-wrap'}>
                              {nextParents && _.get(toggledSections, `${identifier}_${key}`) && (
                                  <OwnershipList
                                      module={module}
                                      block={block}
                                      customData={customData}
                                      childs={nextChilds}
                                      parents={nextParents}
                                      type={currentListType}
                                      openDialog={openDialog}
                                      hasBanner
                                      mainId={mainId}
                                      translates={translates}
                                      renderBanner={renderBanner}
                                      toggledSections={toggledSections}
                                      identifier={`${identifier}_${key}`}
                                      toggleOwnershipSection={toggleOwnershipSection}
                                  />
                              )}
                              {hasBanner &&
                                  _.get(toggledSections, `${identifier}_${key}`) &&
                                  currentListType === PARENTS &&
                                  renderBanner &&
                                  renderBanner(subject.id, currentListType, key === 0, toggleOwnershipSection)}
                              <OwnershipEntity
                                  module={module}
                                  block={block}
                                  customData={customData}
                                  subject={subject}
                                  relation={relation}
                                  mainId={mainId}
                                  translates={translates}
                                  toggledSections={toggledSections}
                                  first={key === 0}
                                  last={key === mapData.length - 1}
                                  parentsPrimary={parentsPrimary}
                                  listType={currentListType}
                                  hasBanner={hasBanner && !!renderBanner}
                                  hasChilds={!_.isEmpty(nextChilds)}
                                  hasParents={!_.isEmpty(nextParents)}
                                  noHistory={noHistory}
                                  identifier={`${identifier}_${key}`}
                                  toggleOwnershipSection={toggleOwnershipSection}
                              />
                              {nextChilds &&
                                  _.get(toggledSections, `${identifier}_${key}`) &&
                                  currentListType === CHILDS && (
                                      <OwnershipList
                                          module={module}
                                          block={block}
                                          customData={customData}
                                          childs={nextChilds}
                                          type={currentListType}
                                          openDialog={openDialog}
                                          hasBanner
                                          mainId={mainId}
                                          renderBanner={renderBanner}
                                          toggledSections={toggledSections}
                                          identifier={`${identifier}_${key}`}
                                          translates={translates}
                                          toggleOwnershipSection={toggleOwnershipSection}
                                      />
                                  )}
                              {hasBanner &&
                                  _.get(toggledSections, `${identifier}_${key}`) &&
                                  currentListType === CHILDS &&
                                  renderBanner(subject.id, currentListType, false, toggleOwnershipSection)}
                          </div>
                      </div>
                  </div>
              ))
            : null
    }
}
